import { CloseOutlined } from '@ant-design/icons';
import type { ScopeSectionRuleTypeName } from '@ydistri/api-sdk';
import React from 'react';
import type { ScopeRuleDefinition, ScopeSectionDraft } from './scopeEditorModel';
import ScopeSectionRules from './ScopeSectionRules';
import type { ScopeRuleMultiselectEntity } from './scopeActiveEntityOptions';
import {
  RemoveRuleSetButton,
  RuleSetCard,
  RuleSetHeader,
  RuleSetHint,
  RuleSetNumber,
} from './ScopeSectionsStyledComponents';

interface ScopeSectionProps {
  getRuleMultiselectData: (
    type: ScopeSectionRuleTypeName,
    selectedValueIds?: number[],
  ) => ScopeRuleMultiselectEntity[];
  hasWarning?: boolean;
  index: number;
  isLoading?: boolean;
  readOnly?: boolean;
  ruleDefinitions: ScopeRuleDefinition[];
  ruleMessagesById?: Record<string, string[]>;
  section: ScopeSectionDraft;
  onRemove: () => void;
  onRulesChange: (rules: ScopeSectionDraft['rules']) => void;
}

const ScopeSection: React.FC<ScopeSectionProps> = ({
  getRuleMultiselectData,
  hasWarning = false,
  index,
  isLoading = false,
  readOnly = false,
  ruleDefinitions,
  ruleMessagesById = {},
  section,
  onRemove,
  onRulesChange,
}) => (
  <RuleSetCard $hasWarning={hasWarning} data-warning={hasWarning || undefined}>
    <RuleSetHeader>
      <RuleSetNumber>Rule set {index + 1}</RuleSetNumber>
      <RuleSetHint>Match all filters</RuleSetHint>
      <RemoveRuleSetButton
        aria-label={`Remove rule set ${index + 1}`}
        danger
        icon={<CloseOutlined />}
        type="text"
        disabled={readOnly}
        onClick={onRemove}
      />
    </RuleSetHeader>
    <ScopeSectionRules
      getRuleMultiselectData={getRuleMultiselectData}
      isLoading={isLoading}
      readOnly={readOnly}
      ruleDefinitions={ruleDefinitions}
      ruleMessagesById={ruleMessagesById}
      rules={section.rules}
      onRulesChange={onRulesChange}
    />
  </RuleSetCard>
);

export default ScopeSection;
